import { Data, TransformsList } from 'cio/utils/analytics/transforms';
import { getModelEntryNameFromId } from 'cio/utils/analytics/transforms/utils';

const Transforms: TransformsList = {
  base(data: Data) {
    return {
      'Snippet ID': data.id,
    };
  },

  listSearched(data: Data & { searchTerm: string; searchResults: number }) {
    return {
      'Search Term': data.searchTerm,
      'Search Results': data.searchResults,
    };
  },

  listSorted(data: Data & { searchTerm: string; searchResults: number; sortBy: string; sortOrder: string }) {
    return {
      'Search Term': data.searchTerm,
      'Search Results': data.searchResults,
      'Sort By': data.sortBy,
      'Sort Order': data.sortOrder,
    };
  },

  detailPageViewed(data: Data) {
    return {
      'Snippet ID': data.model?.id,
      'Snippet Name': data.model?.name,
      'Snippet Usage Count Total': data.model?.messageItems.length,
    };
  },

  listFiltered(data: Data) {
    let objectTypes = getModelEntryNameFromId(JSON.stringify(data.objectTypeIds), data.objectTypes);

    return {
      ...(objectTypes !== false && { 'Filtered by Object Types': objectTypes }),
    };
  },
};

export default Transforms;
